var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _c("h1", { staticClass: "center" }, [_vm._v("Firmendaten")]),
    _vm._v(" "),
    _c("div", { staticClass: "row align-items-top" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("div", { staticClass: "card mt-3" }, [
          _c("div", { staticClass: "card-header" }, [_vm._v("Firmendaten")]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body content-center p-2" }, [
            _c(
              "form",
              {
                staticClass: "form-horizontal justify-content-center",
                attrs: { role: "form" },
              },
              [
                _c("fieldset", [
                  _c("div", { staticClass: "row form-group" }, [
                    _c("div", { staticClass: "col-sm-12" }, [
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "companyname" },
                        },
                        [_vm._v("Firmenname")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.companydata.name,
                            expression: "companydata.name",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "companyname" },
                        domProps: { value: _vm.companydata.name },
                        on: {
                          change: function ($event) {
                            return _vm.setDirty()
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.companydata,
                              "name",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row form-group" }, [
                    _c("div", { staticClass: "col-sm-12" }, [
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "department" },
                        },
                        [_vm._v("Abteilung")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.companydata.department,
                            expression: "companydata.department",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "department" },
                        domProps: { value: _vm.companydata.department },
                        on: {
                          change: function ($event) {
                            return _vm.setDirty()
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.companydata,
                              "department",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-2" }, [
                    _vm._v("Ansprechpartner"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row form-group" }, [
                    _c("div", { staticClass: "col-sm-6" }, [
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "contactfirstname" },
                        },
                        [_vm._v("Vorname")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.companydata.contact_firstname,
                            expression: "companydata.contact_firstname",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "contactfirstname" },
                        domProps: { value: _vm.companydata.contact_firstname },
                        on: {
                          change: function ($event) {
                            return _vm.setDirty()
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.companydata,
                              "contact_firstname",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-6" }, [
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "contactlastname" },
                        },
                        [_vm._v("Nachname")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.companydata.contact_lastname,
                            expression: "companydata.contact_lastname",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "contactlastname" },
                        domProps: { value: _vm.companydata.contact_lastname },
                        on: {
                          change: function ($event) {
                            return _vm.setDirty()
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.companydata,
                              "contact_lastname",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row form-group" }, [
                    _c("div", { staticClass: "col-sm-12" }, [
                      _c(
                        "label",
                        {
                          staticClass: "control-label mt-2",
                          attrs: { for: "email" },
                        },
                        [_vm._v("E-mail")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.companydata.email,
                            expression: "companydata.email",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", readonly: "", id: "email" },
                        domProps: { value: _vm.companydata.email },
                        on: {
                          change: function ($event) {
                            return _vm.setDirty()
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.companydata,
                              "email",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group row" }, [
                    _c(
                      "label",
                      {
                        staticClass: "col-sm-12 control-label mt-2",
                        attrs: { for: "tel" },
                      },
                      [_vm._v("Telefonnummer (optional)")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-12" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.companydata.tel,
                            expression: "companydata.tel",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "tel" },
                        domProps: { value: _vm.companydata.tel },
                        on: {
                          change: function ($event) {
                            return _vm.setDirty()
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.companydata,
                              "tel",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group row" }, [
                    _c("div", { staticClass: "col col-sm-12" }, [
                      _c(
                        "label",
                        {
                          staticClass: "control-label mt-2",
                          attrs: { for: "copmpany_street" },
                        },
                        [_vm._v("Straße und Hausnummer")]
                      ),
                      _vm._v(" "),
                      _c("div", {}, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.companydata.street,
                              expression: "companydata.street",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "copmpany_street" },
                          domProps: { value: _vm.companydata.street },
                          on: {
                            change: function ($event) {
                              return _vm.setDirty()
                            },
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.companydata,
                                "street",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group row" }, [
                    _c("div", { staticClass: "col col-sm-12" }, [
                      _c(
                        "label",
                        {
                          staticClass: "control-label mt-2",
                          attrs: { for: "companySelectedCity" },
                        },
                        [_vm._v("Postleitzahl oder Ort")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.companyZipAndCity,
                            expression: "companyZipAndCity",
                          },
                        ],
                        staticClass: "col-sm-12 form-control",
                        attrs: {
                          type: "text",
                          id: "city",
                          list: "companySelectedCity",
                        },
                        domProps: { value: _vm.companyZipAndCity },
                        on: {
                          change: function ($event) {
                            return _vm.setDirty()
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.companyZipAndCity = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "datalist",
                        { attrs: { id: "companySelectedCity" } },
                        _vm._l(_vm.cityList, function (item) {
                          return _c("option", [
                            _vm._v(
                              "\n                      " +
                                _vm._s(item.plz) +
                                " - " +
                                _vm._s(item.stadt) +
                                "\n                    "
                            ),
                          ])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      !_vm.checkIfCityValid(_vm.companyZipAndCity)
                        ? _c(
                            "label",
                            {
                              staticClass: "control-label text-danger",
                              attrs: { id: "invalidCity" },
                            },
                            [
                              _vm._v(
                                "Die Postleitzahl/Stadt-Kombination ist nicht gültig.\n                    Bitte gib eine gültige Kombination aus der Liste\n                    an."
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-center" }, [
                        _c(
                          "button",
                          {
                            staticClass: "m-3 btn btn-outline-primary",
                            attrs: {
                              type: "button",
                              id: "btnResetCompanyCity",
                            },
                            on: {
                              click: function ($event) {
                                _vm.setDirty()
                                _vm.resetCity()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                      Ort/PLZ leeren\n                    "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col col-sm-12 text-center" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { type: "button", id: "btnSaveCompanyCity" },
                          on: {
                            click: function ($event) {
                              _vm.setDirty()
                              _vm.updateCompanyData()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                    Inhalte Speichern\n                  "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-12" }, [
        _c("div", { staticClass: "card mt-3" }, [
          _c("div", { staticClass: "card-header" }, [
            _vm._v("Rechnungsanschrift"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body content-center p-2" }, [
            _c(
              "form",
              {
                staticClass: "form-horizontal justify-content-center",
                attrs: { role: "form" },
              },
              [
                _c("fieldset", [
                  _c("div", { staticClass: "row form-group" }, [
                    _c("div", { staticClass: "col-sm-12" }, [
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "billingdepartment" },
                        },
                        [_vm._v("Abteilung")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.companydata.billing_department,
                            expression: "companydata.billing_department",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "billingdepartment" },
                        domProps: { value: _vm.companydata.billing_department },
                        on: {
                          change: function ($event) {
                            return _vm.setDirty()
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.companydata,
                              "billing_department",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-2" }, [
                    _vm._v("Ansprechpartner"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row form-group" }, [
                    _c("div", { staticClass: "col-sm-6" }, [
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "billing_contact_firstname" },
                        },
                        [_vm._v("Vorname")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.companydata.billing_contact_firstname,
                            expression: "companydata.billing_contact_firstname",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "billing_contact_firstname",
                        },
                        domProps: {
                          value: _vm.companydata.billing_contact_firstname,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.setDirty()
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.companydata,
                              "billing_contact_firstname",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-6" }, [
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "billing_contact_lastname" },
                        },
                        [_vm._v("Nachname")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.companydata.billing_contact_lastname,
                            expression: "companydata.billing_contact_lastname",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "billing_contact_lastname" },
                        domProps: {
                          value: _vm.companydata.billing_contact_lastname,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.setDirty()
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.companydata,
                              "billing_contact_lastname",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row form-group" }, [
                    _c("div", { staticClass: "col-sm-12" }, [
                      _c(
                        "label",
                        {
                          staticClass: "control-label mt-2",
                          attrs: {
                            for: "billing_email",
                            placeholder: "E-mail",
                          },
                        },
                        [_vm._v("E-mail")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.companydata.billing_contact_email,
                            expression: "companydata.billing_contact_email",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "billing_email" },
                        domProps: {
                          value: _vm.companydata.billing_contact_email,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.setDirty()
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.companydata,
                              "billing_contact_email",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group row mt-2" }, [
                    _c("div", { staticClass: "col-sm-12" }, [
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "billing_contact_telefon" },
                        },
                        [_vm._v("Telefonnummer (optional)")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.companydata.billing_contact_telefon,
                            expression: "companydata.billing_contact_telefon",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "billing_contact_telefon" },
                        domProps: {
                          value: _vm.companydata.billing_contact_telefon,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.setDirty()
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.companydata,
                              "billing_contact_telefon",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group row" }, [
                    _c("div", { staticClass: "col col-sm-12" }, [
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "billing_street" },
                        },
                        [_vm._v("Straße und Hausnummer")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.companydata.billing_street,
                            expression: "companydata.billing_street",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "billing_street" },
                        domProps: { value: _vm.companydata.billing_street },
                        on: {
                          change: function ($event) {
                            return _vm.setDirty()
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.companydata,
                              "billing_street",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group row" }, [
                    _c("div", { staticClass: "col col-sm-12" }, [
                      _c(
                        "label",
                        {
                          staticClass: "control-label mt-2",
                          attrs: { for: "billing_city" },
                        },
                        [_vm._v("Postleitzahl oder Ort")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.billingZipAndCity,
                            expression: "billingZipAndCity",
                          },
                        ],
                        staticClass: "col-sm-12 form-control",
                        attrs: {
                          type: "text",
                          id: "billing_city",
                          list: "selectedbillingCity",
                        },
                        domProps: { value: _vm.billingZipAndCity },
                        on: {
                          change: function ($event) {
                            _vm.setDirty()
                            _vm.checkIfCityValid(_vm.billingZipAndCity)
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.billingZipAndCity = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "datalist",
                        { attrs: { id: "selectedbillingCity" } },
                        _vm._l(_vm.cityList, function (item) {
                          return _c("option", [
                            _vm._v(
                              "\n                      " +
                                _vm._s(item.plz) +
                                " - " +
                                _vm._s(item.stadt) +
                                "\n                    "
                            ),
                          ])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      !_vm.checkIfCityValid(_vm.billingZipAndCity)
                        ? _c(
                            "label",
                            {
                              staticClass: "control-label text-danger",
                              attrs: {
                                id: "invalidBillingCity",
                                for: "textinput",
                              },
                            },
                            [
                              _vm._v(
                                "Die Postleitzahl/Stadt-Kombination ist nicht gültig.\n                    Bitte gib eine gültige Kombination aus der Liste\n                    an."
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-center" }, [
                        _c(
                          "button",
                          {
                            staticClass: "m-2 btn btn-outline-primary",
                            attrs: {
                              type: "button",
                              id: "btnResetBillingCity",
                            },
                            on: {
                              click: function ($event) {
                                _vm.setDirty()
                                _vm.resetBillingCity()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                      Ort/PLZ leeren\n                    "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col col-sm-12 text-center" },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: {
                                  type: "button",
                                  id: "btnSaveCompanyCity",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.setDirty()
                                    _vm.updateCompanyData()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        Inhalte Speichern\n                      "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row align-items-top mt-3" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-header" }, [_vm._v("Passwort")]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body content-center" }, [
            _c(
              "form",
              {
                staticClass: "form-horizontal justify-content-center",
                attrs: { role: "form" },
              },
              [
                _c("fieldset", [
                  _c("div", { staticClass: "form-group row" }, [
                    _c(
                      "label",
                      {
                        staticClass: "control-label col-sm-12 mt-2",
                        attrs: { for: "oldPw" },
                      },
                      [
                        _vm._v(
                          "Bisheriges Passwort (das haben wir uns sicherheitshalber\n                  nicht gemerkt)"
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-12" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.companydata.company_oldPw,
                            expression: "companydata.company_oldPw",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "password", id: "oldPw" },
                        domProps: { value: _vm.companydata.company_oldPw },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.companydata,
                              "company_oldPw",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group row" }, [
                    _c(
                      "label",
                      {
                        staticClass: "control-label col-sm-10 mt-2",
                        attrs: { for: "newPw" },
                      },
                      [_vm._v("Neues Passwort")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-12" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.companydata.company_newPw,
                            expression: "companydata.company_newPw",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "password", id: "newPw" },
                        domProps: { value: _vm.companydata.company_newPw },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.companydata,
                              "company_newPw",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group row" }, [
                    _c(
                      "label",
                      {
                        staticClass: "control-label col-sm-10 mt-2",
                        attrs: { for: "newPwConfirm" },
                      },
                      [_vm._v("Bestätigung neues Passwort")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-12" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.companydata.company_newPwConfirm,
                            expression: "companydata.company_newPwConfirm",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "password", id: "NewPwConfirm" },
                        domProps: {
                          value: _vm.companydata.company_newPwConfirm,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.companydata,
                              "company_newPwConfirm",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-center mt-2" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button" },
                        on: { click: _vm.changePw },
                      },
                      [
                        _vm._v(
                          "\n                  Passwort ändern\n                "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group row mt-3" }, [
                    _c("div", { staticClass: "col col-sm-12" }, [
                      _c("div", { staticClass: "text-center mt-2" }, [
                        false
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-danger",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.activateDeleteBlock()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                      Meinen Account löschen\n                    "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _vm.isDelBlockActive
                        ? _c("div", [
                            _vm._m(0),
                            _vm._v(" "),
                            _c("div", {}, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.companydata.deleteActiveCompany,
                                    expression:
                                      "companydata.deleteActiveCompany",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  id: "DeleteConfirmText",
                                },
                                domProps: {
                                  value: _vm.companydata.deleteActiveCompany,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.companydata,
                                      "deleteActiveCompany",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-center mt-2" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-outline-danger",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.keepCurrentCompany()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        Behalten\n                      "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-danger",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.delCurrentCompany()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        Löschen\n                      "
                                  ),
                                ]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row align-items-center mt-3" }, [_vm._v(" ")]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "control-label", attrs: { for: "DeleteConfirmText" } },
      [
        _vm._v("Bitte gib "),
        _c("span", { staticStyle: { color: "#ff0000" } }, [_vm._v("JA ")]),
        _vm._v(
          " ein,\n                      um den Account wirklich zu löschen"
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }